import React from 'react';

export const RequestManagerContext = React.createContext();
